import { useAppSelector } from '@src/core/hooks';
import { productPackageSelector } from '@src/stores/product';
import useFeatureFlag from '@src/hooks/useFeatureFlag';
import usePackageIdParam from '@src/hooks/usePackageIdParam';
import { shouldUseSingleBookingPackageBooking } from '@src/domains/productPackage';

export function useIsSingleBookingPackageBooking(): boolean {
  const packageId = usePackageIdParam();
  const productPackage = useAppSelector(productPackageSelector(packageId ?? ''));
  const { isFeatureFlagEnabled } = useFeatureFlag();

  return shouldUseSingleBookingPackageBooking(
    productPackage?.configurationMode,
    isFeatureFlagEnabled('PR-4664-product-package-single-journey'),
  );
}
